import { CancelConfirmPanel, IconLibrary, ThriveIcon } from 'thrive-components';

interface IArchiveContentPanelProps {
    existsInMultiplePlaces?: boolean
    title: string, 
    archivalQuestion: string,
    cancelButtonText: string, 
    cancelButtonAriaLabel: string, 
    confirmButtonText: string, 
    confirmButtonAriaLabel: string, 
    handleCancelClick:  (() => void) | ((event: React.MouseEvent<HTMLButtonElement>) => void),
    handleConfirmClick:  (() => void) | ((event: React.MouseEvent<HTMLButtonElement>) => void)
}


const ArchiveContentPanel = ({existsInMultiplePlaces, title, archivalQuestion,cancelButtonText, cancelButtonAriaLabel, confirmButtonText, confirmButtonAriaLabel, handleCancelClick, handleConfirmClick}: IArchiveContentPanelProps) => {

    return (
        <>
            {existsInMultiplePlaces && 
                <div className="archive-content-panel">
                    <div className='archive-question'>
                        <ThriveIcon iconName={IconLibrary.ALERT_INFO} color='var(--thriveLightSlate)' sizeInPx='14' /> 
                        
                        {archivalQuestion}
                    </div>
                </div>
            }

            <div className="archive-content-panel">
                <h1>
                    <ThriveIcon iconName={IconLibrary.ALERT_INFO} color='var(--thriveLightSlate)' sizeInPx='14' /> 
                    
                    {title} 
                </h1>

                <CancelConfirmPanel 
                    panelClassName={`cancel-confirm-modal-panel alert-style`} 
                    cancelContent={cancelButtonText} 
                    confirmContent={confirmButtonText} 
                    ariaLabelCancel={cancelButtonAriaLabel} 
                    ariaLabelConfirm={confirmButtonAriaLabel} 
                    onCancelClick={handleCancelClick} 
                    onConfirmClick={handleConfirmClick} 
                />
            </div>
        </>
    )
};
export default ArchiveContentPanel